export default {
  nav: {
    collection: 'Collection',
    scan: 'Scan',
    cards: 'Cards',
    profile: 'Profile',
  },
  common: {
    all: 'All',
    search: 'Search',
    cancel: 'Cancel',
    confirm: 'Confirm',
    noData: 'No data',
    success: 'Success',
    loading: 'Loading...',
    ownedOnly: 'Owned Only',
    edit: 'Edit',
    delete: 'Delete',
    save: 'Save',
    langJa: 'Japanese',
    langEn: 'English',
    pullRefresh: 'Pull to refresh',
    releaseRefresh: 'Release to refresh',
    noMore: 'All loaded',
  },
  toast: {
    networkError: 'Network error, please check your connection.',
    timeout: 'Request timed out, please try again.',
    invalidRequest: 'Invalid request.',
    sessionExpired: 'Please log in first',
    accessDenied: 'Access denied.',
    notFound: 'Resource not found.',
    invalidParams: 'Invalid parameters.',
    tooManyRequests: 'Too many requests, please slow down.',
    serverError: 'Server error, please try again later.',
    loginRequired: 'Please sign in first.',
    addSuccess: 'Added to collection.',
    removeSuccess: 'Removed from collection.',
    quantityUpdated: 'Quantity updated.',
    saveSuccess: 'Saved successfully.',
    signOutSuccess: 'Signed out.',
    searchEmpty: 'Please enter a card ID.',
    uploadSuccess: 'Uploaded successfully.',
    notCamera: 'Camera access denied.',
    firstCard: 'This is the first card.',
    lastCard: 'This is the last card.',
    emailEmpty: 'Please enter your email address.',
    emailInvalid: 'Please enter a valid email address.',
    codeEmpty: 'Enter 6-digit code',
    addSuccess: 'Added to collection',
    googleSdkNotReady: 'Google service is not ready, please try again later',
    linkCopied: 'Link copied!',
  },
  signin: {
    subtitle: 'One Piece Card Tracker',
    emailLabel: 'Email Address',
    emailPlaceholder: 'captain@grandline.com',
    verificationCode: 'Verification Code',
    send: 'Send',
    resend: 'Resend',
    signIn: 'Sign In',
    autoRegister: 'New users will be registered automatically.',
    quickLogin: 'Quick Login',
    lastLogin: 'Last Login',
  },
  collection: {
    searchPlaceholder: 'Search cards, sets, codes…',
    searchedCards: 'Results',
    totalValue: 'Total Collection Value',
    totalCards: 'Total Cards',
    sortHighToLow: 'Price: High to Low',
    sortLowToHigh: 'Price: Low to High',
    recentlyAdded: 'Recently Added',
    guestTitle: 'Start Your Collection',
    guestDesc: 'Sign in to track, manage and value your card collection.',
    guestFeature1: 'Track every card you own',
    guestFeature2: 'Monitor real-time market prices',
    guestFeature3: 'Scan cards instantly with your camera',
    emptyTitle: 'Your collection is empty',
    emptyDesc: 'Scan or search cards to start your collection',
    scanCards: 'Scan Cards',
    searchCards: 'Add by Search',
    gradedValue: 'Graded Value',
    ungradedValue: 'Raw Value',
    filter: 'Filter',
    filterTitle: 'Filter & Sort',
    sortBy: 'Sort By',
    language: 'Language',
    langJP: 'Japanese',
    langEN: 'English',
    cardType: 'Card Type',
    cardTypeAll: 'All',
    cardTypeGraded: 'Graded',
    cardTypeRaw: 'Raw',
    resetFilter: 'Reset',
    applyFilter: 'Apply',
    plLabel: 'P&L',
    sortPnlHighToLow: 'P&L: High to Low',
    sortPnlLowToHigh: 'P&L: Low to High',
    select: 'Select',
    selectedCount: 'Selected {count}',
    selectAll: 'Select All',
    move: 'Move',
    delete: 'Delete',
    moveToGroup: 'Move to Group',
    moveCards: 'Move {count} cards to:',
    confirmMove: 'Confirm Move',
    moveSuccess: 'Moved successfully',
    deleteConfirmMsg: 'Delete {count} cards? This cannot be undone.',
    confirmDelete: 'Confirm Delete',
    deleteSuccess: 'Deleted successfully',
  },
  cardDetail: {
    title: 'Card Details',
    cardId: 'Card ID',
    rarity: 'Rarity',
    language: 'Language',
    version: 'Version',
    type: 'Type',
    foil: 'Foil',
    yourHolding: 'Your Holding',
    owned: 'Owned',
    market: 'Market Price',
    lastUpdated: 'Last Updated',
    ungradedPrice: 'Raw Price',
    totalValue: 'Total value',
    addToCollection: 'Add To Collection',
    addCard: 'Add Card',
    cardCondition: 'Card Condition',
    selectCondition: 'Select Condition',
    totalPaid: 'Total Paid',
    pricePerCard: 'Paid',
    qtyMinError: 'Quantity must be at least 1',
    totalPaidRequired: 'Please enter the total paid amount',
    profitLabel: 'P&L',
    gradeHint: '*Grade cannot be changed after adding',
    remove: 'Remove',
    profitableGrades: 'Profitable Grades',
    moreGrades: 'More Grades',
    marketPrices: 'Market Prices',
    convertHint: 'The platform will convert to USD',
  },
  scan: {
    title: 'Scan',
    manual: 'Manual',
    alignCard: 'Align the card within the frame.',
    scanCard: 'Scan a card to get started.',
    scanBtn: 'Scan',
    searchCards: 'Search Cards',
    pointCamera: 'Point the camera at the card and hold steady.',
    unidentified: 'Card not identified.',
    cardsIdentified: 'cards identified',
    scanSuccess: 'Card identified.',
    cardLanguage: 'Card Language',
    cardId: 'Card ID',
    cardIdPlaceholder: 'e.g. OP01-060',
    tapToCapture: 'Tap the button below to take a photo.',
    takePhoto: 'Take Photo',
    fromAlbum: 'Choose from Album',
    clear: 'Clear',
    qty: 'Qty',
    rescan: 'Rescan',
    failedHint:
      'Help improve card data to earn Beli points after approval, redeemable for rewards',
    alignLabel: 'Align grading label here',
    failedFeedbackDesc: 'Incorrect result, submitting a card issue',
  },
  cards: {
    searchPlaceholder: 'Search sets…',
    searchInSet: 'Search cards…',
    allSets: 'All Sets',
    of: 'of',
  },
  setDetail: {
    sortPriceDesc: 'Value: High to Low',
    sortPriceAsc: 'Value: Low to High',
    sortByNumber: 'By Number',
  },
  profile: {
    email: 'Email',
    language: 'Language',
    langEn: 'English',
    langZhTW: '繁體中文',
    editUsername: 'Edit Username',
    usernamePlaceholder: 'Enter a username.',
    saveUsername: 'Save',
    editAvatar: 'Change Avatar',
    signOut: 'Sign Out',
    guest: 'Start Your Collection',
    guestDesc: 'Sign in to unlock your full collection.',
    feature1: 'Track and manage your card collection',
    feature2: 'Monitor real-time market prices',
    feature3: 'Scan cards instantly with your camera',
    loginMethod: 'Login Method Management',
    googleAccount: 'Google Account',
    notBound: 'Not Bound',
    bind: 'Bind',
    unbind: 'Unbind',
    googleBound: 'Google account has been bound',
    googleUnbound: 'Google account has been unbound',
    keepOneLogin: 'At least one login method must be kept',
    bound: 'Bound',
    currency: 'Currency',
    aboutUs: 'About Us',
    termsDoc: 'Terms & Conditions',
    privacyDoc: 'Privacy Policy',
    currencyUSD: 'USD',
    currencyHKD: 'HKD',
    currencyJPY: 'JPY',
    feedbackHistory: 'Feedback History',
  },
  report: {
    title: 'Report an Issue',
    imageIssue: 'Image Issue',
    priceIssue: 'Price Issue',
    missingCard: 'Missing Card',
    other: 'Other',
    placeholder: 'Please describe the issue...',
    submit: 'Submit',
    successToast: 'Feedback Success',
    feedback: 'Feedback',
    uploadImage: 'Attachment',
    optional: '(Optional)',
    uploadHint: 'Add photo',
    uploadImageLabel: 'Image',
    rewardHint:
      'Help improve card data to earn Beli points after approval, redeemable for rewards',
  },
  asset: {
    totalValue: 'Total Collection Value',
    totalSpent: 'Total Spent',
    change: 'Change',
    ungraded: 'RAW',
    graded: 'GRADED',
    valueTrend: 'Value Trend',
    topTreasures: 'Top Treasures',
    ungraded_label: 'Raw',
    noData: 'No data yet',
    ungradedLabel: 'Raw',
    paid: 'Paid',
    value: 'Value',
    qty: 'Qty',
    topGainersTitle: 'Market Top Gainers',
    topGainersSubtitle: 'Based on market price growth ranking',
    totalPaid: 'Total Paid',
    guestBadge: 'Managing Assets',
    guestTitleLine1: 'Scan, Collect, &',
    guestTitleLine2: 'Master Your Cards',
    viewMore: 'View More',
    viewLess: 'View Less',
    noCollectionData: 'No collection data yet.',
  },
  trend: {
    priceTrend: 'Price Trend',
    ungraded: 'Raw',
    graded: 'Graded',
    pop: 'POP',
  },
  feedback: {
    resolved: 'Resolved',
    processing: 'Processing',
    closed: 'Closed',
    viewCard: 'View Card',
  },
  group: {
    title: 'My Groups',
    viewing: 'Viewing',
    newGroup: 'New Group',
    manage: 'Manage Groups',
    default: 'Default',
    done: 'Done',
    inputPlaceholder: 'Enter group name (max 20 chars)',
    create: 'Create',
    createSuccess: 'Group created',
    renameSuccess: 'Renamed successfully',
    deleteSuccess: 'Group deleted',
    deleteConfirmTitle: 'Delete Group',
    deleteConfirmMsg: 'Delete group "{name}"?\n{count} cards will be moved to "{defaultGroup}".',
    confirmDelete: 'Delete',
    allGroupsDesc: 'View all collected cards',
    currentGroup: 'Current Group',
    cards: 'Cards',
  },
}
